<mat-card>
    <form matForm [formGroup]='formGrouping' (ngSubmit)="save($event)">
        <div formArrayName="formArray">
            <mat-card-header>

            </mat-card-header>
            <mat-card-content>
                <mutara-alert statusType="success" icon="check" label="Your account has been verified"
                    description="Complete registration by choosing a password"></mutara-alert>
                <div class="display-flex">
                    <div>
                        <b>{{login?.firstname}} {{login?.lastname}}</b>
                        ({{login?.nickname}})
                        <br>{{login?.email}}
                        <br>{{login?.phone}}
                    </div>

                    <div class='username-password' formGroupName='0'>
                        <p>Username:<br />
                            {{login?.email}}</p>
                        <input hidden #username [value]="login?.email">

                        <mat-form-field required>
                            <mat-label>Registration Password</mat-label>
                            <input matInput #password formControlName='password' placeholder="ex: bubbl3Gum!"
                                [type]="hide ? 'password' : 'text'">
                           
                        </mat-form-field>
                        <mutara-alert description="Password rules: minmum 8 characters, at least 3 of the following; lowercase, uppercase, numbers, symbols"></mutara-alert>
                    </div>
                </div>
                <mat-card-actions align='end'>
                    <button mat-flat-button type='button' (click)="save($event)" color="primary">Register and
                        Begin</button>
                </mat-card-actions>
            </mat-card-content>
        </div>
    </form>
</mat-card>